import React from 'react'
import NavigationBar from '../../../components/Navigationbar/Navigationbar'
import Headline from '../../../components/headline/Headline'
import { useState } from 'react';
import { Token } from '../../../Script/Session';
import { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { post } from '../../../Script/Session';
import Stylebutton from '../../../components/buttons/stylebutton/Stylebutton';
import { haspermission } from '../../../Script/Permission';
import CreateKathegorieForm from './components/CreateKathegorieForm';
import KatheGorie from './components/KatheGorie';
import { Box, Button, Input } from '@mui/joy';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import SearchIcon from '@mui/icons-material/Search';
function VergleichsKathegorien() {
    const [wit, setwith] = useState("90.5%");
    const [data, setData] = useState("");
    const navigate = useNavigate();
    useEffect(() => {
        const fetchVereinData = async () => {
            const body = {
                token: Token.get(),
                action: "get",
            };

            try {
                let response = await post(body, "/vergleiche/Sparten");
                if (response === "LOGOUT") {
                    navigate("/");
                    return;
                }

                setData(JSON.parse(response));
                console.log(response);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchVereinData();
    }, [navigate]);


    function update() {

        const body = {
            token: Token.get(),
            action: "get",
        };

        try {
            let response = post(body, "/vergleiche/Sparten");
            if (response === "LOGOUT") {
                navigate("/");
                return;
            }

            setData(JSON.parse(response));
            console.log(response);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }
    const [canEditpage, seteditpage] = useState(haspermission("19"));
    const [pagelog, setpagelog] = useState(haspermission("17"));
    const [create, setcreate] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    return (

        <>
            {create && (
                <CreateKathegorieForm upd={update} setc={setcreate} />

            )}
            <div style={{ width: wit, position: "fixed", zIndex: 1, flexDirection: "column", top: "0", right: "0", height: "100vh", display: "flex", alignItems: "center" }}>
                <Headline title={"Sparten"} />
                <div style={{ overflowX: "hidden", overflowY: "auto", listStyle: "none", height: "94.5%", width: "100%", backgroundColor: "transparent", padding: "0px", display: "flex", alignItems: "center", flexDirection: "column", marginTop: "0%" }}>
                    <div style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        padding: "1rem",
                    }}>
                        <div style={{ width: "25%", fontSize: "16px", color: "gray", paddingLeft: "1rem" }}>
                            <p style={{ marginLeft: "10%" }}><strong>|</strong> Spartenname</p>
                        </div>
                        <div style={{ width: "25%", fontSize: "16px", color: "gray", paddingLeft: "1rem" }}>
                            <p></p>
                        </div>
                        <div style={{ width: "25%", fontSize: "16px", color: "gray", paddingLeft: "1rem" }}>
                            <p style={{ marginLeft: "70%" }}><strong>|</strong> Bearbeiten</p>
                        </div>
                        <div style={{ width: "25%", fontSize: "16px", color: "gray", paddingLeft: "1rem", flexDirection: "row", alignItems: "center", justifyContent: "flex-end", display: "flex" }}>
                            {canEditpage && (
                                <div style={{ marginRight: "5%" }} onClick={() => setcreate(true)}><Stylebutton buttonText={"Erstellen"} /></div>

                            )}
                            {
                                pagelog && (
                                    <div style={{ marginRight: "5%" }} onClick={() => navigate("/page-history/vergleichsKathegorien")}><Stylebutton buttonText={"SeitenHistorie"} /></div>
                                )
                            }

                        </div>
                    </div>
                    <Box sx={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", mb: 2 }}>
                        <Input
                            placeholder="Suche..."
                            startDecorator={<SearchIcon />}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            sx={{ width: 600 }}
                        />
                    </Box>

                    <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", zIndex: "0" }}>
                        {data.value && data.value.filter(item =>
                            item.name.toLowerCase().includes(searchTerm.toLowerCase())).map(i =>
                                <KatheGorie key={i.id} canedit={canEditpage} upd={update} item={i} list={data.value} />
                            )}
                        <div style={{ height: "30px" }}></div> {/* Spacer at the bottom */}
                    </div>

                </div>
            </div>
            <NavigationBar state={"vergleiche"} back={true} />
        </>
    )
}

export default VergleichsKathegorien
